"use client"

import Link from "next/link"
import { usePathname, useRouter } from "next/navigation"
import { useI18n } from "./client"
import { localeHref, withoutLocale } from "./routing"
import styles from "./language-switcher.module.css"

export function LanguageSwitcher({ full = false }: { full?: boolean }) {
  const { locale } = useI18n()
  const pathname = withoutLocale(usePathname() ?? "/")
  const router = useRouter()
  const navigate = (target: "en" | "es") => (event: { preventDefault: () => void }) => {
    event.preventDefault()
    router.push(localeHref(pathname, target) + window.location.search + window.location.hash)
  }
  if (full) return <nav className={styles.full} aria-label={locale === "es" ? "Idioma" : "Language"} translate="no"><Link href={localeHref(pathname, "en")} onNavigate={navigate("en")} lang="en" hrefLang="en-US" aria-current={locale === "en" ? "true" : undefined}>English</Link><Link href={localeHref(pathname, "es")} onNavigate={navigate("es")} lang="es" hrefLang="es-US" aria-current={locale === "es" ? "true" : undefined}>Español</Link></nav>
  const target = locale === "en" ? "es" : "en"
  return <Link className={styles.compact} href={localeHref(pathname, target)} onNavigate={navigate(target)} lang={target} hrefLang={target === "es" ? "es-US" : "en-US"} aria-label={target === "es" ? "Ver esta página en español" : "View this page in English"} translate="no">{target.toUpperCase()}</Link>
}
